<template>
    <DropdownSlot
        ref="dropdown"
        :name="label"
        :label="text"
        :icon="icon"
        :cls="
            (cls || '') +
                ' select ' +
                (multiple ? 'dulplite' : 'single') +
                (filterShow ? ' show-filter' : '') +
                (isMobileSize ? ' mobile' : '')
        "
        :hide_name="hide_name"
        :container="containerRef"
        :mobileStyleWhenMobile="mobileStyleWhenMobile"
        :inner_cls="'panel-style ' + (inner_cls || '')"
        :dropdownIcon="dropdownIcon"
        :filterShow="filterShow && !isMobileSize"
        :showSortBy="showSortBy"
        @filterChange="filterChange"
        @toogledropdown="toogledropdown"
    >
        <li class="filter-content" v-if="filterShow && isMobileSize">
            <i class="iconfont icon-search"></i>
            <input
                type="search"
                autocomplete="off"
                placeholder="Input any value here"
                class="filter-input"
                maxlength="50"
                v-model="searchKey"
            />
            <div v-show="isMobileSize" class="close" @click="onClose">
                Close
            </div>
        </li>
        <li
            v-for="item in filterOptions"
            :class="item.selected ? 'selected' : ''"
            :key="item.value"
            @click="select(item.value)"
        >
            <span>{{ item.label }}</span>
            <em v-show="item.selected" class="iconfont icon-checked-light"></em>
        </li>
    </DropdownSlot>
</template>
<script>
import DropdownSlot from './dropdown-slot.vue';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import { fetchFilterItemOptions } from '@/modules/md-search-bar/api';
export default {
    emits: ['change', 'toogledropdown', 'open'],
    props: [
        'label',
        'icon',
        'kee',
        'multiple',
        'show_count',
        'options',
        'cls',
        'inner_cls',
        'hide_name',
        'container',
        'inMore',
        'conditions',
        'value',
        'defaultValue',
        'dropdownIcon',
        'showAny',
        'mobileStyleWhenMobile', // The mobile terminal adopts the mobile terminal style
        'canCancel', //  Support unchecked ,
        //select label exist select Won't be translated when not expanded ，select Initialize the selected value in select The input box is not translated 。 exist condition During initialization all its label will be translated ， So pass this attribute to select Fix translation issues in 。
        'conditionsLabels',
        'getOptionsAsync',
        'showSortBy'
    ],
    i18next: {
        ns: 'common'
    },
    components: { DropdownSlot },
    name: 'GlobalSelect',
    data: function() {
        return {
            split: ',',
            containerRef: null,
            searchKey: ''
        };
    },
    computed: {
        ...mapState(usePageStore, ['siteId']),
        isMobileSize() {
            return this.platform.isMobile
        },
        optionsMap() {
            let optionsMap = {};
            Array.isArray(this.options) &&
                this.options.forEach(
                    option =>
                        (option.value || option.value === 0) &&
                        (optionsMap[option.value] = option.label)
                );
            return optionsMap;
        },
        text() {
            if (this.value) {
                // current select If there is a value, the current select The options need to be translated
                if (this.multiple) {
                    if (this.show_count) {
                        let len = this.value.split(this.split).length;
                        return len > 1
                            ? this.label + `(${len})`
                            : this.optionsMap[this.value] || this.label;
                    } else {
                        return this.value
                            .split(this.split)
                            .map(value => this.optionsMap[value])
                            .join(this.split);
                    }
                } else {
                    return this.optionsMap[this.value] || this.label;
                }
            }
            return this.showAny ? this.$t('common:any') : this.label;
        },
        computedOptions() {
            return Array.isArray(this.options)
                ? this.options.map(option => {
                    if (typeof option.value === 'number') {
                        option.value = option.value + ''; 
                    }
                    option = Object.assign({}, option);
                    option.selected = false;
                    if (!this.value && !option.value) {
                        option.selected = true;
                    } else {
                        if (this.multiple) {
                            let values = this.value.split(this.split);
                            if (values.indexOf(option.value) !== -1) {
                                option.selected = true;
                            }
                        } else {
                            if (option.value == this.value) {
                                // for option.value = 0 and this.value = ''
                                if (
                                    !option.value &&
                                      option.value !== this.value
                                ) {
                                    option.selected = false;
                                } else {
                                    option.selected = true;
                                }
                            }
                        }
                    }
                    return option;
                })
                : [];
        },
        filterShow() {
            let flag = false;
            if (
                Array.isArray(this.options) &&
                this.options.length > 10 &&
                this.inMore
            ) {
                flag = true;
            }
            if (
                this.isMobileSize &&
                Array.isArray(this.options) &&
                this.options.length > 2 &&
                this.inMore
            ) {
                flag = true;
            }
            return flag;
        },
        filterOptions() {
            return this.computedOptions.filter(option => {
                const label = (option.label || '').toLowerCase();
                // if (typeof label !== 'string' && label.description) {
                //     label = label.description.toLowerCase();
                // }
                return (
                    !this.filterShow ||
                    label.indexOf(this.searchKey.trim().toLowerCase()) >= 0
                );
            });
        }
    },
    mounted() {
        if (typeof this.value === 'undefined' && this.defaultValue) {
            this.value = this.defaultValue;
        }
        this.$nextTick(
            () => (this.containerRef = this.$parent.$refs[this.container])
        );
        if (this.getOptionsAsync) {
            this.getOptionList();
        }
    },
    methods: {
        select(value) {
            let newValue = this.value;
            let labels = [];
            if (this.multiple && value) {
                let values = [];
                this.computedOptions.forEach(option => {
                    if (
                        option.value &&
                        ((option.value == value && !option.selected) ||
                            (option.value != value && option.selected))
                    ) {
                        values.push(option.value);
                        labels.push(option.label);
                    }
                });
                newValue = values.join(this.split);
            } else if (this.multiple && !value) {
                newValue = value;
            } else {
                // Radio support cancel  begin
                if (this.canCancel && value) {
                    this.computedOptions.forEach(option => {
                        if (
                            option.value &&
                            !option.selected &&
                            option.value == value
                        ) {
                            newValue = value;
                        } else if (
                            option.value &&
                            option.selected &&
                            option.value == value
                        ) {
                            newValue = '';
                        }
                    });
                } else {
                    newValue = value;
                }
                labels.push(this.optionsMap[newValue]);
                //end
            }
            this.onChange(newValue, labels);
            if (!this.multiple && !(this.filterShow && this.isMobileSize)) {
                this.$refs.dropdown && this.$refs.dropdown.close();
            }
        },
        onChange(value, labels) {
            this.$emit('change', {
                kee: this.kee,
                value: value,
                labels: labels,
                type: 'select',
                multiple: this.multiple,
                split: this.split,
                inMore: this.inMore
            });
        },
        toogledropdown(open) {
            this.$emit('toogledropdown', {
                open,
                options: this.options,
                name: this.kee
            });
        },
        open() {
            this.$emit('open');
        },
        filterChange(value) {
            this.searchKey = value;
        },
        onClose() {
            this.$refs.dropdown && this.$refs.dropdown.close();
        },
        getOptionList() {
            fetchFilterItemOptions.call(this, {
                siteId: this.siteId,
                type: this.kee
            })
                .then(data => {
                    const newOptions = data || [];
                    this.$emit('changeOptions', newOptions);
                })
                .catch(e => {
                    console.error(e);
                });
        }
    },
    watch: {
        value: {
            // immediate: true,
            handler: function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    let labels = [];
                    let value = '';
                    if (this.multiple && newValue) {
                        let values = [];
                        let newValues = newValue.split(this.split);
                        this.computedOptions.forEach(option => {
                            if (
                                option.value &&
                                newValues.indexOf(option.value) !== -1
                            ) {
                                values.push(option.value);
                                labels.push(option.label);
                            }
                        });
                        value = values.join(this.split);
                    } else {
                        value = newValue;
                        labels.push(this.optionsMap[newValue]);
                    }
                    // this.onChange(value, labels);
                }
            }
        }
    }
};
</script>
